import Timeline from '../components/Timeline';
import LightboxGallery from '../components/LightboxGallery';
import Slider from 'react-slick';
import '../css/weddingPage.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import foto1 from '../images/foto 1.jpeg';
import foto2 from '../images/foto 2.jpeg';
import foto3 from '../images/foto 3.jpeg';
import foto4 from '../images/foto 4.jpeg';
import foto5 from '../images/foto 5.jpeg';
import foto6 from '../images/foto 6.jpeg';
import foto7 from '../images/foto 7.jpeg';
import foto8 from '../images/foto 8.jpeg';
import foto9 from '../images/foto 9.jpeg';
import foto10 from '../images/foto 10.jpeg';
import foto11 from '../images/foto 11.jpeg';

export default function DiaDosNamorados() {
  const fotos = [
    foto1, foto2, foto3, foto4, foto5, foto6, foto7, foto8,
    foto9, foto10, foto11
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <>
      <section className="story-section">
        <Timeline
          events={[
            { date: '', title: 'Em 2019, o destino nos colocou lado a lado em um projeto de trabalho. Aos poucos, a convivência se transformou em admiração e respeito, e aquilo que começou como uma parceria profissional deu lugar a uma amizade sincera.' },
            { date: '', title: 'Depois de 11 meses de risadas, conversas e momentos compartilhados, essa amizade floresceu em algo ainda mais especial: um lindo amor.' },
            { date: '', title: 'Cinco anos se passaram desde aquele encontro que mudou nossas vidas. Hoje, sentimos que é o momento perfeito para dar o próximo passo e celebrar tudo o que construímos juntos. Decidimos oficializar nosso amor diante de Deus, de nossa família e de nossos amigos — aqueles que sempre torceram por nós e fazem parte dessa história.' },
          ]}
        />
      </section>

      <section className="gallery-section">
        <h2>Nossas Memórias 💞</h2>
        <Slider {...settings}>
          {fotos.map((src, i) => (
            <div key={i} className="slider-img-w">
              <img src={src} alt={`Foto ${i + 1}`} className="slider-img" />
            </div>
          ))}
        </Slider>
        <LightboxGallery images={fotos} className="" />
      </section>
    </>
  );
}
